import AuthService from '../../service/auth.js'
export default {
  'data': function () {
    return {
      isOpen: false,
      user: AuthService.state
    }
  },
  'methods': {
    'openMenu': function () {
      this.isOpen = !this.isOpen
    },
    'logout': function () {
      AuthService.removeToken()
      this.$router.push('/')
      this.isOpen = false
    }
  }
}



// WEBPACK FOOTER //
// ./src/component/menu-top/menu-top.js